import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { DatatableColumn, RktTableComponent } from '@rocketfinancialcorp/rocket-ui/table';
import { DetailsItemComponent, DetailsPageContentPlaceholderComponent } from '@shared/components';
import { DetailsItemIdComponent } from '@shared/components/details-item-id/details-item-id.component';
import { DateFormatPipe, TeamMemberNamePipe } from '@shared/pipes';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';
import { EditRestrictionsComponent } from '@shared/components/financial-account/edit-restrictions/edit-restrictions.component';
import { FinancialAccountRestriction } from '@shared/models';
import { FinancialAcccountActions, financialAccountFeature } from 'src/app/+state/financial-account-feature';

@Component({
  selector: 'app-financial-account-details',
  templateUrl: './financial-account-details.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RktIconComponent,
    DetailsPageContentPlaceholderComponent,
    DetailsItemComponent,
    DetailsItemIdComponent,
    DateFormatPipe,
    RktTableComponent,
    TeamMemberNamePipe,
    RktIconComponent,
  ],
})
export class FinancialAccountDetailsComponent {
  store = inject(Store);
  modalService = inject(ModalService);

  financialAccount$ = this.store.select(financialAccountFeature.selectFinancialAccountDetails);

  restrictionsColumns: DatatableColumn[] = [
    { name: 'Solution', prop: 'solution', flexSize: 100 },
    { name: 'Transaction Type', prop: 'transactionType', flexSize: 150 },
    { name: 'Withholding Period', prop: 'withholdingPeriod', flexSize: 150 },
    { name: 'Withholding Period Type', prop: 'withholdingPeriodType', flexSize: 180 },
    { name: 'Created At', prop: 'createdAt', flexSize: 180, colType: 'date' },
    { name: 'Updated At', prop: 'updatedAt', flexSize: 180, colType: 'date', colAlign: 'right' },
  ];

  onEditBtnClick(restrictions: FinancialAccountRestriction[], id: string) {
    const accountModalRef = this.modalService.open(EditRestrictionsComponent, {
      className: 'entity-form-modal',
    });

    accountModalRef.componentInstance.initModalData(restrictions, id);
    accountModalRef.result.then(
      (restrictions) => {
        if (restrictions) this.store.dispatch(FinancialAcccountActions.loadFinancialAccountDetails());
      },
      () => false,
    );
  }
}
